export const jobOffer = {
  title: 'Putzer / Stuckateur (m/w/d)',
  location: 'Hollfeld & Umgebung',
  type: 'Vollzeit · Festanstellung',
  intro:
    'Wir suchen Verstärkung für unser Team! Du packst mit an, arbeitest sauber und hast Lust auf ein bodenständiges Handwerk? Dann bist du bei uns genau richtig.',
  salary: '23 €',
  salaryLabel: 'Eintrittsgehalt pro Stunde',
  facts: [
    { icon: 'ri-money-euro-circle-line', label: 'Eintrittsgehalt', value: '23 € / Std.' },
    { icon: 'ri-briefcase-line', label: 'Arbeitsumfang', value: 'Vollzeit · 40 Std.' },
    { icon: 'ri-calendar-check-line', label: 'Urlaub', value: '30 Tage' },
    { icon: 'ri-time-line', label: 'Arbeitszeit', value: '6:30 – 15:00 Uhr' },
    { icon: 'ri-car-line', label: 'Fahrtweg', value: 'wird bezahlt' },
    { icon: 'ri-file-list-3-line', label: 'Lebenslauf & Anschreiben', value: 'nicht nötig' },
  ],
  benefits: [
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Faire Bezahlung',
      text: '23 € Eintrittsgehalt pro Stunde. Faire, pünktliche Bezahlung — deine Arbeit wird ehrlich entlohnt.',
    },
    {
      icon: 'ri-car-line',
      title: 'Fahrtweg wird bezahlt',
      text: 'Dein Fahrtweg zu den Baustellen wird übernommen und bezahlt. Kein Stillstand, kein Verlust.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: '30 Tage Urlaub',
      text: 'Überdurchschnittlich viel Erholung — damit du langfristig fit und motiviert bleibst.',
    },
    {
      icon: 'ri-time-line',
      title: 'Feste Arbeitszeiten',
      text: 'Von 6:30 bis 15:00 Uhr — klare Struktur und dein Feierabend gehört dir.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Kein Lebenslauf & Anschreiben nötig',
      text: 'Weder Lebenslauf noch Anschreiben nötig. Ein kurzer Anruf genügt — wir lernen uns einfach kennen.',
    },
    {
      icon: 'ri-team-line',
      title: 'Bodenständiges Team',
      text: 'Ein regionaler Handwerksbetrieb aus Hollfeld mit kurzen Wegen, klaren Worten und fairem Umgang.',
    },
  ],
  requirements: [
    'Du bist Putzer oder Stuckateur und arbeitest sauber und zuverlässig.',
    'Eine abgeschlossene Ausbildung als Maler oder Maurer ist von Vorteil — aber kein Muss.',
    'Du packst mit an, bist pünktlich und arbeitest gerne im Team.',
    'Führerschein der Klasse B ist hilfreich für die Fahrt zu den Baustellen.',
  ],
};